/** BranchID values from sales import SQL / Excel (BranchID column). */
export const SALES_IMPORT_BRANCH_NAMES = {
  "1": "Main",
  "10": "Branch",
  "11": "Spareway",
};

/** Outward Supply voucher type per branch (SQL export labels). */
export const BRANCH_OUTWARD_SUPPLY_VOUCHER_TYPES = {
  "1": "Outward Supply",
  "10": "Outward Supply Br",
  "11": "Outward Supply Spareway",
};

const KNOWN_ORDER = ["1", "10", "11"];

export function normalizeSalesImportBranchId(branchId) {
  const raw = String(branchId ?? "").trim();
  if (!raw) return "";
  const n = Number(raw);
  if (Number.isFinite(n) && !Number.isNaN(n)) return String(n);
  return raw;
}

export function salesImportBranchName(branchId) {
  const id = normalizeSalesImportBranchId(branchId);
  if (!id) return "";
  return SALES_IMPORT_BRANCH_NAMES[id] ?? "";
}

/** e.g. "11 — Spareway" or raw id if unknown */
export function salesImportBranchDisplayName(branchId) {
  const id = normalizeSalesImportBranchId(branchId);
  if (!id) return "Unknown";
  const name = salesImportBranchName(id);
  return name ? `${id} — ${name}` : id;
}

/** Branch filter label for discount / outward-supply reports — includes voucher type. */
export function salesImportBranchOutwardSupplyLabel(branchId) {
  const id = normalizeSalesImportBranchId(branchId);
  const name = SALES_IMPORT_BRANCH_NAMES[id] ?? "";
  const voucherType = BRANCH_OUTWARD_SUPPLY_VOUCHER_TYPES[id];
  if (name && voucherType) return `${name} (${id}) — ${voucherType}`;
  return salesImportBranchDisplayName(branchId);
}

export function outwardSupplyVoucherTypeForBranch(branchId) {
  const id = normalizeSalesImportBranchId(branchId);
  return BRANCH_OUTWARD_SUPPLY_VOUCHER_TYPES[id] || BRANCH_OUTWARD_SUPPLY_VOUCHER_TYPES["1"];
}

export function sortSalesImportBranchIds(ids) {
  return [...new Set((ids || []).map((id) => normalizeSalesImportBranchId(id)).filter(Boolean))].sort(
    (a, b) => {
      const ia = KNOWN_ORDER.indexOf(a);
      const ib = KNOWN_ORDER.indexOf(b);
      if (ia >= 0 && ib >= 0) return ia - ib;
      if (ia >= 0) return -1;
      if (ib >= 0) return 1;
      return a.localeCompare(b, undefined, { numeric: true });
    }
  );
}

export const SALES_IMPORT_BRANCH_OPTIONS = sortSalesImportBranchIds(
  Object.keys(SALES_IMPORT_BRANCH_NAMES)
);

export function salesImportBranchIdFromRow(row) {
  return normalizeSalesImportBranchId(row?.branchId ?? row?.BranchID ?? row?.branch ?? "") || "Unknown";
}

export function rowMatchesSalesImportBranch(row, branchId) {
  if (!branchId || branchId === "all") return true;
  return salesImportBranchIdFromRow(row) === normalizeSalesImportBranchId(branchId);
}

export function filterRowsBySalesImportBranch(rows, branchId) {
  if (!branchId || branchId === "all") return rows || [];
  return (rows || []).filter((r) => rowMatchesSalesImportBranch(r, branchId));
}

const BRANCH_STORAGE_KEY = "sdic-branch-id";

export function readSalesImportBranchFilter() {
  try {
    const v = localStorage.getItem(BRANCH_STORAGE_KEY);
    return v && v !== "all" ? normalizeSalesImportBranchId(v) || "all" : v || "all";
  } catch {
    return "all";
  }
}

export function writeSalesImportBranchFilter(branchId) {
  try {
    localStorage.setItem(BRANCH_STORAGE_KEY, branchId || "all");
  } catch {
    /* ignore */
  }
}
